import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BrComService } from '../../service/BrComService';
import { AuthWebProvider, QRCodeAuth } from '../../providers/auth-web/auth-web';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { AreaLocalProvider } from '../../providers/area-local/area-local';
import { ContatoLocalProvider } from '../../providers/contato-local/contato-local';
import { InicialPage } from '../../pages/inicial/inicial';

@IonicPage()
@Component({
  selector: 'page-login-web',
  templateUrl: 'login-web.html',
})
export class LoginWebPage {

  public qrCode: QRCodeAuth;
  private subInterval: Subscription;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private authWeb: AuthWebProvider, 
    private brComService: BrComService,
    private areaLocalProvider: AreaLocalProvider,
    private contatoLocalProvider: ContatoLocalProvider) {
    this.authWeb.buscarQRCode(this.brComService.readAppDomain()).subscribe(
      (result: QRCodeAuth) => {
        this.qrCode = result;
        this.verificarAutorizaçãoQRCode();
      }
    )
  }

  private verificarAutorizaçãoQRCode(): void {
    this.subInterval = interval(5000).subscribe(
      () => {
        let autenticado = false;
        if (this.qrCode) {
          const appDomain = this.brComService.getAppDomain();
          const imei = this.brComService.obtemImei();
          this.authWeb.verificaSePossuiAutorizacaoWeb(this.qrCode.uuid, imei, appDomain).subscribe(
            (usuario: any) => {
              if (usuario && !autenticado) {
                autenticado = true;
                this.subInterval.unsubscribe();
                this.armazenarDadosUsuario(usuario);
              }
            }
          )
        }
    }, (error) => {
      console.log(error);
    });
  }

  private armazenarDadosUsuario(usuarios: any): void {
    // melhorar a organização do localstorage com definições do usuário/empresa depois da primeira versão
    if (Array.isArray(usuarios)) {
      usuarios = usuarios[0];
    } 
    this.areaLocalProvider.setAreas(usuarios.Areas);
    this.contatoLocalProvider.setContatos(usuarios.Contatos);
    delete usuarios.Areas;
    delete usuarios.Contatos;
    // o sistema de autenticação deve ser melhorado.
    usuarios.Autenticado = true;
    this.brComService.brComDao.gravaGrupo([usuarios]);
    this.navCtrl.setRoot(InicialPage);
    this.navCtrl.popToRoot({});
  }

  ngOnDestroy() {
    this.subInterval.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/pages/login-web/login-web.ts